import React from "react";
import { Outlet } from "react-router-dom";
import { useRouteActivity } from "~/hooks/useRouteActivity";
import { usePageContentFallback } from "~/hooks/usePageContentFallback";

/**
 * Renders route-specific or generic content fallback while a child loader runs.
 * Filter/pagination (query-only) navigations keep the mounted page (stage 2).
 */
export const PageFallbackOutlet: React.FC = () => {
  const { showContentFallback } = useRouteActivity();
  const ContentFallback = usePageContentFallback();

  if (showContentFallback) {
    return <ContentFallback />;
  }

  return <Outlet />;
};
